class FetchAiProviders {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAiProviders;
